// extracted by mini-css-extract-plugin
module.exports = {"otpInputBox":"OtpInput_otpInputBox__e6b-u"};